'use strict';

const capencyHelper = require('core/capencyHelper');

var capPhoneConfig = [];
var urlCapPhoneConfig = $('#url-cap-phone-config').val();
var urlCapPhone = $('#url-cap-phone').val();
const base = require('capencyBase/capency/phone/function');
const invalidFeedback = require('capency/capency/utils/invalidFeedback');

$.ajax({
    url: urlCapPhoneConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capPhoneConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});

/**
* Processes the phone number validation flow for a given form configuration.
*
* This function initiates an AJAX request to validate the phone number entered in the form.
* Depending on the response, it updates the form's state, displays error messages, and enables or disables form submission buttons.
*
* @param {Object} currentFormConfig - The configuration object for the current form.
* @param {string} currentFormConfig.idPhone - The ID of the phone input field.
* @param {string} currentFormConfig.idForm - The ID of the form to be processed.
*
* @returns {void}
*/
function callProcessPhoneFlow(currentFormConfig) {
    var $phoneSelector = $('#' + currentFormConfig.idPhone);
    var $formSelector = $("form[id='" + currentFormConfig.idForm + "']");
    var $currentPhoneCode = $('#phoneCode', $formSelector);
    var currentCountry = $currentPhoneCode.length > 0 ? $currentPhoneCode.data('countryCode').toUpperCase() : 'FR';
    let $invalidFeedback = invalidFeedback.getInvalidFeedbackElement($phoneSelector);

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + currentFormConfig.idForm + "']");
    }

    let origin = $phoneSelector.attr('data-origin');

    if ($phoneSelector.data('lastChecked') && $phoneSelector.val() && $phoneSelector.data('lastChecked').replace(/\s+/g, "") === $phoneSelector.val().replace(/\s+/g, "")) {
        if ($phoneSelector.data('lastValidated')) {
            $phoneSelector.val($phoneSelector.data('lastChecked'));
            capencyHelper.setFieldValid($phoneSelector, true);
            $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', false);
        } else {
            capencyHelper.setFieldValid($phoneSelector, false);
            $invalidFeedback.show();
            $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', true);
        }
        return;
    }

    $.spinner().start();
    $.ajax({
        url: urlCapPhone,
        method: 'GET',
        data: {
            sTel: $phoneSelector.val(),
            sIsoPays: currentCountry,
            idForm: currentFormConfig.idForm,
            origin: origin || ''
        },
        success: function (data) {
            if (data.sCodeRetour === 'XXXXXX') {
                $phoneSelector.data('validated', true);
                $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', false);
                $.spinner().stop();
                return;
            }

            if (data.errorMessage) {
                $.spinner().stop();
                capencyHelper.setFieldValid($phoneSelector, false);
                $phoneSelector.data('lastValidated', false);
                $phoneSelector.data('lastChecked', $phoneSelector.val());
                $invalidFeedback.empty().html(data.errorMessage).show();
                $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', true);
                return false;
            }

            if (data.iReturnValue === 0) {
                const phoneValue = data.phoneFlow[0].sTel.replace(`+${data.phoneFlow[0].sIndicatifOut} `,'').replace(/-/g, '');
                $phoneSelector.val(phoneValue);
                capencyHelper.setFieldValid($phoneSelector, true);
                $phoneSelector.data('lastValidated', true);
                $phoneSelector.data('lastChecked', phoneValue);
                $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', false);
            } else {
                capencyHelper.setFieldValid($phoneSelector, false);
                $phoneSelector.data('lastValidated', false);
                $phoneSelector.data('lastChecked', $phoneSelector.val());
                $('.submit-shipping, .submit-payment, .account-save-addr-btn').prop('disabled', true);
            }
            $.spinner().stop();
        }
    });
}

base.callProcessPhoneFlow = callProcessPhoneFlow
module.exports = base;
